import { Box, CircularProgress, styled } from '@mui/material';
import { createContext, PropsWithChildren, useContext, useMemo } from 'react';
import { useFetching } from './use-fetching';

const StyledBox = styled(Box)({
  position: 'fixed',
  backgroundColor: 'white',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
  width: '100vw',
  zIndex: 9999,
});

const LoadingContext = createContext<{ isFetching: boolean }>({
  isFetching: false,
});

function LoadingContextProvider({ children }: PropsWithChildren) {
  const isFetching = useFetching();

  const contextValue = useMemo(() => ({ isFetching }), [isFetching]);

  return (
    <LoadingContext.Provider value={contextValue}>
      {isFetching && (
        <StyledBox>
          <CircularProgress />
        </StyledBox>
      )}
      {children}
    </LoadingContext.Provider>
  );
}

const useLoadingContext = () => useContext(LoadingContext);

export { LoadingContext, LoadingContextProvider, useLoadingContext };
